'use strict'
import './home.css'
import * as THREE from 'three'
// import * as dat from 'lil-gui'
import gsap from 'gsap'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
// import typefaceFont from 'three/examples/fonts/helvetiker_regular.typeface.json'
/**
 * Debug
 */
//const gui = new dat.GUI()

const parameters = {
  materialColor: '#00b300'
}

//gui
//    .addColor(parameters, 'materialColor')
//    .onChange(() =>
//    {
//        material.color.set(parameters.materialColor)
//        particlesMaterial.color.set(parameters.materialColor)
//    })

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const group = new THREE.Group()
scene.add(group)

/**
 * Objects
 */
// Texture
const textureLoader = new THREE.TextureLoader()
const gradientTexture = textureLoader.load('textures/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter

// Material
const material = new THREE.MeshToonMaterial({
    color: parameters.materialColor,
    gradientMap: gradientTexture
})

// Objects
const objectsDistance = 6
const mesh1 = new THREE.Mesh(
  new THREE.TorusGeometry(.475, 0.3, 16, 60),
  material
)
const mesh2 = new THREE.Mesh(
  new THREE.BoxGeometry(1.25, 1.25, 1.25),
  material
)
const mesh3 = new THREE.Mesh(
  new THREE.TorusKnotGeometry(0.5, 0.22, 100, 16),
  material
)
const mesh4 = new THREE.Mesh(
  new THREE.CylinderGeometry(0.5, 0.5, 1, 8),
  material
)
const mesh5 = new THREE.Mesh(
  new THREE.ConeGeometry(0.75, 1, 32 ),
  material
)

mesh1.position.x = 0.25
mesh2.position.x = -0.25
mesh3.position.x = 0.25
mesh4.position.x = -0.25
mesh5.position.x = 0.25

mesh1.position.y = - objectsDistance * 0 - 1.5
mesh2.position.y = - objectsDistance * 1 - 1.5
mesh3.position.y = - objectsDistance * 2 - 1.5
mesh4.position.y = - objectsDistance * 3 - 1.5
mesh5.position.y = - objectsDistance * 4 - 1.5

scene.add(mesh1, mesh2, mesh3, mesh4, mesh5)

const sectionMeshes = [ mesh1, mesh2, mesh3, mesh4, mesh5 ]

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 1)
directionalLight.position.set(1, 1, 0)
scene.add(directionalLight)

/**
 * Particles
 */
// Geometry
const particlesCount = 200
const positions = new Float32Array(particlesCount * 3)

for(let i = 0; i < particlesCount; i++)
{
    positions[i * 3 + 0] = (Math.random() - 0.5) * 10
    positions[i * 3 + 1] = objectsDistance * 0.5 - Math.random() * objectsDistance * sectionMeshes.length
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

// Material
const particlesMaterial = new THREE.PointsMaterial({
    color: '#ffffff',
    sizeAttenuation: textureLoader,
    size: 0.03
})

// Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)

/**
 * Textures
 */
//const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('textures/matcaps/8.png')
const textureLoader2 = new THREE.TextureLoader()
const matcapTexture2 = textureLoader2.load('textures/matcaps/2.png')

/**
 * Fonts
 */
const fontLoader = new FontLoader()

fontLoader.load(
  '/fonts/helvetiker_regular.typeface.json',
  (font) => {
    // Material
    const material = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
    const material2 = new THREE.MeshMatcapMaterial({ matcap: matcapTexture2 })

    // Text
    const textGeometry = new TextGeometry(
      `Paul Oosterhoff`,
      {
        font: font,
        size: 0.15,
        height: 0.03,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 3
      }
    )
    textGeometry.center()
    const text = new THREE.Mesh(textGeometry, material2)
    text.position.y = 1.5
    group.add(text)

    // Text
    const textGeometry2 = new TextGeometry(
      `Web Developer`,
      {
        font: font,
        size: 0.15,
        height: 0.03,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 2
      }
    )
    textGeometry2.center()

    const text2 = new THREE.Mesh(textGeometry2, material)
    text2.position.y = 1
    group.add(text2)

    group.rotation.y = Math.PI * 0.125
    // Donuts
    // const donutGeometry = new THREE.TorusBufferGeometry(0.3, 0.2, 32, 64)
    const donutGeometry = new THREE.ConeBufferGeometry(0.5, 0.5, 8, 1)

    for (let i = 0; i < 500; i++) {
      const donut = new THREE.Mesh(donutGeometry, material)
      donut.position.x = (Math.random() - 0.5) * 10
      donut.position.y = (Math.random() - 0.5) * 50
      donut.position.z = (Math.random() - 0.5) * 10
      donut.rotation.x = Math.random() * Math.PI
      donut.rotation.y = Math.random() * Math.PI
      const scale = Math.random() * .3
      donut.scale.set(scale, scale, scale)

      scene.add(donut)
    }
  }
)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Group
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 9
cameraGroup.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Scroll
 */
let scrollY = window.scrollY
let currentSection = 0

window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY
    const newSection = Math.round(scrollY / sizes.height)

    if(newSection != currentSection)
    {
        currentSection = newSection

        gsap.to(
            sectionMeshes[currentSection].rotation,
            {
                duration: 1.5,
                ease: 'power2.inOut',
                x: '+=6',
                y: '+=3',
                z: '+=1.5'
            }
        )
    }
})

/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', (event) =>
{
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Animate camera
    camera.position.y = - scrollY / sizes.height * objectsDistance

    const parallaxX = cursor.x * 0.5
    const parallaxY = - cursor.y * 0.5
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 5 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 5 * deltaTime

    // Animate meshes
    for(const mesh of sectionMeshes)
    {
        mesh.rotation.x += deltaTime * 0.1
        mesh.rotation.y += deltaTime * 0.12
    }

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()